/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class SMGeneratorAPI {
  async Generate(hint : string, style : st.WritingStyle) : Promise<any> {
    return await componentApi.call('st', 'sm-generator', 'SMGeneratorAPI', 'Generate', {
      hint,
      style,
    });
  }
}
export default new SMGeneratorAPI()
